import React from 'react';
import './DragDropOverlay.css';
import { IoCloudUploadOutline } from 'react-icons/io5';
import { useLanguage } from '../../../../LanguageProvider';

export default function DragDropOverlay({ isVisible }) {
    const { getTranslation } = useLanguage();
    if (!isVisible) return null;

    return (
        <div className="drag-drop-overlay">
            <div className="drag-drop-content">
                <div className="drag-drop-icon">
                    <IoCloudUploadOutline size={48} />
                </div>
                <h2 className="drag-drop-title">
                    {getTranslation("dropFilesHere")}
                </h2>
                <p className="drag-drop-description">
                    {getTranslation("dropFilesDescription")}
                </p>
            </div>
        </div>
    );
}
